import { Toast } from '@seiue/ui'
import CryptoJS from 'crypto-js'
import { zeusApi } from 'packages/sdks-next/growp'
import { getUrlParams } from 'packages/utils'

/**
 * 获取加密后的参数
 *
 * @param param0 - 参数
 * @param param0.message - 需要加密的参数
 * @param param0.encodeKey - 加密key
 * @returns {string} - 加密后的参数
 */
export const getEncodeString = ({
  message,
  encodeKey,
}: {
  message: string
  encodeKey: string
}): string => {
  const encryptedParam: string = CryptoJS.AES.encrypt(
    message,
    encodeKey
  ).toString()
  const encodedCiphertext = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(encryptedParam)
  )
  return encodedCiphertext
}

/**
 * 解码
 *
 * @param encodedString - string
 * @param key - key
 * @returns string
 */
export const decodeString = (encodedString: string, key: string) => {
  try {
    const ciphertext = CryptoJS.enc.Base64.parse(encodedString).toString(
      CryptoJS.enc.Utf8
    )
    const plaintext = CryptoJS.AES.decrypt(ciphertext, key).toString(
      CryptoJS.enc.Utf8
    )
    return plaintext
  } catch (error) {
    return null
  }
}

/**
 * 获取随机字符串
 *
 * @param len - 长度
 * @returns 随机字符串
 */
export const getRandomString = (len = 10) => {
  const timestamp = new Date().getTime()
  const randomPart = CryptoJS.lib.WordArray.random(4).toString(
    CryptoJS.enc.Base64
  )
  const randomString = CryptoJS.SHA256(timestamp.toString() + randomPart)
    .toString(CryptoJS.enc.Base64)
    .slice(0, len)
  return randomString
}

/**
 * 验证url参数
 *
 * @param isPreview - 是否是预览
 * @returns 校验后的参数
 */
export const useValidUrlParams = (isPreview?: boolean) => {
  const param = getUrlParams('param', location.search)
  const { data: urlMsg, loading } = zeusApi.useLoadUrlHash(
    { hash: param || '' },
    { disable: !param || isPreview }
  )
  if (isPreview || (loading && !urlMsg)) return undefined
  if (!urlMsg) {
    Toast.error('资源不存在，登录活动请输入正确的分享链接')
    location.href = '/404'
    return undefined
  }

  return urlMsg
}

/**
 * 校验 home 页的 url 参数
 *
 * @returns 校验后的参数
 */
export const useValidHomeUrl = () => {
  const search = location.search

  // 分享链接格式是 https://activity.growp.net?xxxxx
  // ? 后面的是 hash 数据，如果用户输入的 url 符合分享链接的格式，就开始校验登录活动的 url 参数
  const param = search.startsWith('?') ? location.search.slice(1) : undefined
  const { data: urlMsg, loading } = zeusApi.useLoadUrlHash(
    { hash: param || '' },
    { disable: !param }
  )
  if (!param || (loading && !urlMsg)) return undefined
  if (!urlMsg) {
    Toast.error('资源不存在')
    Toast.warning('登录活动请输入正确的分享链接')
    location.href = '/404'
    return undefined
  }

  return urlMsg
}
